import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#support-form");
const divModel: HTMLDivElement = document.querySelector("#divChineseSupportModel");

export class ViewModel {
    busy = ko.observable(false);

    name = ko.observable<string>();
    phone = ko.observable<string>();
    email = ko.observable<string>();

    submit: () => void;

    constructor() {
        let self = this;

        self.busy.subscribe(newVal => App.busy(newVal));

        self.submit = () => {
            if (!self.busy())
                self.send();
        }
    }

    private clear() {
        let self = this;

        self.name("");
        self.phone("");
        self.email("");
    }

    private send() {
        let self = this;

        self.busy(true);

        var data = self.toJson();

        Api.ChineseSupport(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                App.alertSuccess(results.message);
                self.clear();
            })
            .always(() => self.busy(false));
    }

    private toJson() {
        let self = this;

        var data = {
            name: self.name(),
            phone: self.phone(),
            email: self.email()
        }

        return data;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(), divRoot);
    }
}

$(document).ready(() => init());